import * as userActions from '../../reducers/user';

const updateOktaSSOValue = (key, value) => (dispatch) => {
  dispatch(userActions.updateOktaSSOValue({ key, value }));
};

export default updateOktaSSOValue;
